import { render, staticRenderFns } from "./SidInputWithDimension.vue?vue&type=template&id=71e01614"
import script from "./SidInputWithDimension.vue?vue&type=script&lang=js"
export * from "./SidInputWithDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports